import footerLogo from "assets/images/footer-logo.png";
import { Link } from "components/Link";
import { getYear } from "date-fns";
import { FooterConstants } from "footer-utils";
import type React from "react";
import { Fragment } from "react";
import { useTranslation } from "react-i18next";
import { ParagraphSmall } from "styles/elements/Texts";
import { StyledContactWrapper, StyledFooter, StyledImageWrapper } from "./Footer.styled";

export const Footer: React.FC = () => {
  const { t } = useTranslation("common");
  const { contactLinks, genericLinks } = FooterConstants();
  const today = new Date();
  return (
    <StyledFooter>
      <StyledImageWrapper data-cy="footer-logo-img" background={footerLogo} />
      <StyledContactWrapper>
        {contactLinks.links.map((link) => (
          <Link key={link.url} external={link.external} to={link.url} variant="default">
            <ParagraphSmall margin="0.5rem">{link.label}</ParagraphSmall>
          </Link>
        ))}
        <ParagraphSmall margin="0.5rem">
          {t("footer.copyrightNotice", { currentYear: getYear(today) })}
        </ParagraphSmall>
      </StyledContactWrapper>
      <StyledContactWrapper>
        {genericLinks.links.map((link, index) => (
          <Fragment key={link.url}>
            {index > 0 && <span>&nbsp;|&nbsp;</span>}
            <Link external={link.external} size="xs" to={link.url}>
              {link.label}
            </Link>
          </Fragment>
        ))}
      </StyledContactWrapper>
    </StyledFooter>
  );
};
